// extracted by mini-css-extract-plugin
export default {"header":"HistoryHeader_header__NHrdy","smallScreen":"HistoryHeader_smallScreen__n2xIP","row":"HistoryHeader_row__iV0gA"};